<ng-container *transloco="let t">
  <ng-container *ngIf="user$ | async as user">
    <table class="table" *ngIf="downloads?.length; else noHistory">
      <thead>
        <tr>
          <th>{{ t('dlHisVersion.label') }}</th>
          <th>{{ t('dlHisDate.label') }}</th>
          <th>{{ t('dlHisFile.label') }}</th>
          <th *ngIf="!environment.production">{{ t('dlHisSubset.label') }}</th>
          <th>{{ t('dlHisDownloadedBy.label') }}</th>
          <th>{{ t('dlHisDownload.label') }}</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let dl of downloads">
          <td>
            <span
              class="download__version"
              [title]="ariaCadenceVersion(dl.cadenceName, dl.cadenceVersion)"
            >
              {{ dl.cadenceName }} {{ dl.cadenceVersion }}
            </span>
          </td>
          <td>
            <span class="download__date" [title]="dl.date">
              {{ dl.date | translocoDate: { dateStyle: 'short' } }}
            </span>
          </td>
          <td>
            <span title="{{ dl.assetType | assetType }}">{{
              dl.assetType | assetType
            }}</span>
          </td>
          <td *ngIf="!environment.production">
            <button *ngIf="dl.assetType === 'deploymentAssets' && dl.suSubset && dl.suSubset.length > 0"
            tabindex="0"
            class="btn btn-lightweight subset-list-btn"
            attr.aria-label="{{ t('dlHisSubsetListButton.aria') }}"
            [dropdownTriggerFor]="subsetListDropdown"
            (click)="displaySubsetList(dl.suSubset)"
            >
            {{ t('dlHisSubsetListButton.title') }}
            </button>
          </td>
          <td>
            <span class="download__user">
              {{ dl.user }}
            </span>
          </td>
          <td>
            <div class="action-btn-container">
              <button
                tabindex="0"
                class="btn btn-primary"
                attr.aria-label="{{ t('dlHisDownloadFiles.aria') }}"
                [title]="dl.name"
                (click)="downloadHistoricAsset(dl)"
                [disabled]="downloadBtnDisabled$ | async"
              >
                {{ t('dlHisDownload.label') }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <ng-template #noHistory>
    <div class="zero-state-container">
      <svg
        localeOverrides="{}"
        xmlns="http://www.w3.org/2000/svg"
        class="ZeroStateSave"
        width="158"
        height="94"
        version="1.1"
        viewBox="0 0 158 94"
        xml:space="preserve"
      >
        <path
          class="ZScolor1OpacityDots"
          fill="#86134F"
          d="M150,54c0-0.552,0.448-1,1-1c0.552,0,1,0.448,1,1s-0.448,1-1,1 C150.448,55,150,54.552,150,54z M151,49c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S150.448,49,151,49z M157,55 c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S156.448,55,157,55z M145,67c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S144.448,67,145,67z M145,61c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S144.448,61,145,61z M139,43c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S138.448,43,139,43z M145,55c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S144.448,55,145,55z M139,55c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S138.448,55,139,55z M139,49c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S138.448,49,139,49z M127,37c0.552,0,1-0.448,1-1s-0.448-1-1-1 s-1,0.448-1,1S126.448,37,127,37z M127,31c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1s-1,0.448-1,1C126,30.552,126.448,31,127,31z M127,43c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S126.448,43,127,43z M133,37c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S132.448,37,133,37z M133,55c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S132.448,55,133,55z M133,61c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S132.448,61,133,61z M133,67c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S132.448,67,133,67z M127,61c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S126.448,61,127,61z M121,61 c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S120.448,61,121,61z M127,49c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1 S126.448,49,127,49z M121,43c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S120.448,43,121,43z M115,49c0.552,0,1-0.448,1-1 s-0.448-1-1-1s-1,0.448-1,1S114.448,49,115,49z M115,43c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S114.448,43,115,43z M115,36 c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S114.448,36,115,36z M121,73c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1 S120.448,73,121,73z M121,67c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S120.448,67,121,67z M115,67c0.552,0,1-0.448,1-1 s-0.448-1-1-1s-1,0.448-1,1S114.448,67,115,67z M31,61c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S30.448,61,31,61z M37,43c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S36.448,43,37,43z M43,49c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S42.448,49,43,49z M43,43c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S42.448,43,43,43z M37,55 c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S36.448,55,37,55z M43,37c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1 S42.448,37,43,37z M31,55c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S30.448,55,31,55z M31,37c0.552,0,1-0.448,1-1 s-0.448-1-1-1c-0.552,0-1,0.448-1,1S30.448,37,31,37z M19,31c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1c-0.552,0-1,0.448-1,1 C18,30.552,18.448,31,19,31z M19,25c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1c-0.552,0-1,0.448-1,1C18,24.552,18.448,25,19,25z M25,49c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S24.448,49,25,49z M19,43c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S18.448,43,19,43z M25,43c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S24.448,43,25,43z M13,37 c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S12.448,37,13,37z M31,31c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1 c-0.552,0-1,0.448-1,1C30,30.552,30.448,31,31,31z M19,49c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S18.448,49,19,49z M13,49c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S12.448,49,13,49z M13,55c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S12.448,55,13,55z M13,67c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S12.448,67,13,67z M13,61 c0.552,0,1-0.448,1-1s-0.448-1-1-1c-0.552,0-1,0.448-1,1S12.448,61,13,61z M1,37c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1 S0.448,37,1,37z M7,37c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S6.448,37,7,37z M19,37c0.552,0,1-0.448,1-1s-0.448-1-1-1 c-0.552,0-1,0.448-1,1S18.448,37,19,37z M7,55c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S6.448,55,7,55z"
          opacity="0.15"
        ></path>
        <path
          class="ZScolor1Opacity"
          fill="#86134F"
          d="M95,86.586l9.293-9.293c0.391-0.391,1.023-0.391,1.414,0 c0.391,0.39,0.391,1.024,0,1.414l-11,11c-0.39,0.39-1.024,0.39-1.414,0l-11-11c-0.391-0.39-0.391-1.024,0-1.414 c0.391-0.391,1.023-0.391,1.414,0L93,86.586H95z"
          opacity="0.1"
        ></path>
        <path
          class="ZScolor1"
          fill="#86134F"
          d="M105,17v50c0,0.552-0.448,1-1,1h-3.438H100v-1h4V17H53v37.608L64.438,67H88v1H64.438 c-0.279,0-0.545-0.117-0.735-0.322L52.265,55.287C52.095,55.103,52,54.86,52,54.609V17c0-0.552,0.448-1,1-1h51 C104.552,16,105,16.448,105,17z M90,45v10c0,0.552-0.448,1-1,1H67c-0.552,0-1-0.448-1-1V45c0-0.552,0.448-1,1-1h22 C89.552,44,90,44.448,90,45z M89,45H67v10h22V45z M96,27v11c0,0.552-0.448,1-1,1H62c-0.552,0-1-0.448-1-1V27c0-0.552,0.448-1,1-1h33 C95.552,26,96,26.448,96,27z M95,27H62v11h33V27z M94,54L94,54c0.552,0,1,0.448,1,1v29.586l9.293-9.293 c0.391-0.391,1.023-0.391,1.414,0c0.391,0.39,0.391,1.024,0,1.414l-11,11c-0.39,0.39-1.024,0.39-1.414,0l-11-11 c-0.391-0.39-0.391-1.024,0-1.414c0.391-0.391,1.023-0.391,1.414,0L93,84.586V55C93,54.448,93.448,54,94,54z"
        ></path>
      </svg>
      <p>{{ t('dlHisNoHistory.txt') }}</p>
    </div>
  </ng-template>

  <dropdown #subsetListDropdown>
    <div class="subset-list-container">
      <h4 class="subset-list-title">
        {{ t('dlHisSubsetDropdown.title') }}
      </h4>
      <ul class="subset-list">
        <li *ngFor="let deploymentAsset of displayedDeploymentAssets" class="subset-list-item">
          {{ deploymentAsset.legalName }}
        </li>
      </ul>
    </div>
  </dropdown>

</ng-container>
